<template>
    <li>
        <template v-if="modelValue.details.child.value.length > 0">
            <button
                @click="toggle"
                type="button"
                :class="modelValue.active ? 'border-blue-500 text-blue-500' : 'border-transparent text-slate-500'"
                class="inline-block border-l-4 py-2 pl-6 pr-4 font-medium"
            >
                {{ modelValue.details.label }}
            </button>
            <menu-tertiary
                v-if="modelValue.details.toggle"
                :modelValue="modelValue.details.child.value"
            ></menu-tertiary>
        </template>
        <template v-else>
            <a
                :class="modelValue.active ? 'text-blue-500' : 'text-slate-500'"
                class="border-transparent hover:text-blue-600 inline-block border-l-4 py-2 pl-6 pr-4"
                :href="modelValue.details.link"
                v-text="modelValue.details.label"
            ></a>
        </template>
    </li>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';
import MenuTertiary from "./MenuTertiary.vue";

const props = defineProps({
    modelValue: {
        type: Object,
        default: () => ({
            id: '',
            active: false,
            details: {
                link: '',
                label: '',
                toggle: true,
                child: {
                    value: [],
                    enabled: false
                }
            }
        })
    }
});


const emit = defineEmits(['update:modelValue']);

const toggle = () => {
    props.modelValue.details.toggle = !props.modelValue.details.toggle;
    emit('update:modelValue', props.modelValue);
};
</script>

<style scoped>
/* Add your styles here */
</style>
